import { cva } from 'class-variance-authority'

/**
 * Hover aligned with LinkButton `text-link` / `text-highlighted` (Button `link` / `link-highlighted`):
 * brand-1 blue on hover + underline toggled (on if off at rest, off if on at rest).
 */
export const textLinkCva = cva(
  'group/link underline-offset-2 outline-none data-[hovered]:text-[--text-link-fg-hover] data-[hovered]:decoration-[--text-link-decoration-hover] data-[focus-visible]:outline data-[focus-visible]:outline-2 data-[focus-visible]:outline-brand-1-700 active:!outline-none',
  {
    variants: {
      underlined: {
        invert: 'underline data-[hovered]:no-underline',
        hover: 'no-underline data-[hovered]:underline',
        none: 'no-underline data-[hovered]:no-underline',
      },
      bold: { true: 'font-bold', false: 'font-medium' },
      tint: {
        'brand-1': 'text-[--text-link-fg-brand-1]',
        'brand-2': 'text-[--text-link-fg-brand-2]',
      },
    },
    defaultVariants: { underlined: 'invert', bold: false, tint: 'brand-2' },
  },
)
